<mat-card class="large-card">
    <div class="settingsBody" style="width: 98%">
        <div class="settings-heading">Position Management</div>

        <mat-tab-group
            #example1
            (selectedTabChange)="handleTabChange($event)"
            ActiveTabIndex="tab"
            useAutomaticActivation
            class="settings"
        >
            <mat-tab *ngFor="let tab of tabs" [label]="tab.label" class="settings"></mat-tab>
        </mat-tab-group>
        <br />

        <!-- Positions -->
        <ng-container *ngIf="tab === 0">
            <p class="section-title">
                Set the default permission set for each position by selecting the permission set
                from the Default Permission dropdown list. All positions must have a default
                permission set.
            </p>
            <br />

            <table cellpadding="0" cellspacing="0" class="position-table">
                <thead>
                    <tr>
                        <th>Position</th>
                        <th>Category</th>
                        <th>Class</th>
                        <th>Job Titles</th>
                        <th>Default Permission</th>
                        <th>Hierarchy Level</th>
                        <th>
                            <span
                                matTooltip="Default home page after Login"
                                [matTooltipPosition]="'above'"
                                >Home Page</span
                            >
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="!allPositionsData || !permissionSetData">
                        <td colspan="7">
                            <spin-loader [type]="'bounce'"></spin-loader>
                        </td>
                    </tr>
                    <ng-container *ngIf="permissionSetData && allPositionsData">
                        <tr *ngFor="let position of allPositionsData">
                            <td>{{ position.position }}</td>
                            <td>{{ position.category }}</td>
                            <td>{{ position.class }}</td>
                            <!--<td>{{ position.jobTitles }}</td>-->
                            <td class="td-link">
                                <a
                                    matTooltip="{{ position.jobTitles }}"
                                    [matTooltipPosition]="'above'"
                                    matTooltipClass="tooltip-pos"
                                    >{{
                                        position.jobTitles == null ? 0 : position.jobTitles.length
                                    }}</a
                                >
                            </td>
                            <td>
                                <select
                                    [(ngModel)]="position.permissionSetKey"
                                    (ngModelChange)="updatePositionPermissionMapping(position)"
                                >
                                    <option value="0">None</option>
                                    <option
                                        *ngFor="let permission of permissionSetData"
                                        [value]="permission.permissionSetKey"
                                    >
                                        {{ permission.name }}
                                    </option>
                                </select>
                            </td>
                            <td>
                                <select
                                    [(ngModel)]="position.roleName"
                                    (ngModelChange)="updatePositionPermissionMapping(position)"
                                >
                                    <!--<option value="none">None</option>-->
                                    <option
                                        *ngFor="let role of hierarchyRoleLevels"
                                        [value]="role.roleName"
                                    >
                                        {{ role.roleName }}
                                    </option>
                                </select>
                            </td>
                            <td>
                                <select
                                    [(ngModel)]="position.homePageKey"
                                    (ngModelChange)="updatePositionPermissionMapping(position)"
                                >
                                    <option [value]="0">nCino Mortgage Analytics Home</option>
                                    <ng-container
                                        *ngIf="
                                            position.permissionSetPages &&
                                            position.permissionSetPages.length != 0
                                        "
                                    >
                                        <option
                                            *ngFor="let page of position.permissionSetPages"
                                            [value]="page.applicationPageKey"
                                        >
                                            {{ page.module }} {{ page.name }}
                                        </option>
                                    </ng-container>
                                </select>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
            <div class="button-container">
                <button
                    mat-button
                    primary
                    [disabled]="
                        !positionPermissionMappingUpdateData ||
                        positionPermissionMappingUpdateData.length <= 0
                    "
                    (click)="savePositionPermissionMapping()"
                >
                    Save &nbsp;
                    <i class="far fa-save"></i>
                </button>
                &nbsp;&nbsp;
                <button
                    mat-button
                    (click)="cancelPositionPermissionMapping()"
                    [disabled]="
                        !positionPermissionMappingUpdateData ||
                        positionPermissionMappingUpdateData.length === 0
                    "
                >
                    Cancel
                </button>
            </div>
        </ng-container>

        <!-- Permissions -->
        <ng-container *ngIf="tab === 1">
            <app-permission-set-management></app-permission-set-management>
        </ng-container>

        <!-- Job Mapping -->
        <ng-container *ngIf="tab === 2">
            <p class="section-title">
                Assign each Job Title to a default Position by selecting the Position from the
                dropdown list. Job Titles can only be assigned to one Position. For each Job Title,
                add its Job Code (optional) in the corresponding text box. By default, new employees
                will automatically be assigned to the default Position based on the employees’ job
                titles.
            </p>

            <div
                class="job-title-search-box-area"
                style="
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                "
            >
                <mat-form-field fluid appearance="outline" class="example-full-width">
                    <mat-label>Find Job Title</mat-label>
                    <input
                        matInput
                        [(ngModel)]="searchTerms"
                        class="search-field"
                        style="width: 250px !important"
                        (ngModelChange)="filterSearch()"
                        [ngModelOptions]="{ standalone: true }"
                    />
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>

                <div style="display: flex; flex-direction: row; gap: 0.75rem; align-items: center">
                    <span style="font-weight: 500">Position: </span>
                    <select [(ngModel)]="selectedItem" (ngModelChange)="filterPosition()">
                        <option
                            *ngFor="let option of searchFilterPositionOptions"
                            [value]="option.staffPositionKey"
                        >
                            {{ option.position }}
                        </option>
                    </select>
                </div>

                <!--<button mat-button
                primary
                mat-stroked-button
                (click)="autoMapJobTitleClick()"
                style="position:absolute; bottom:5px; right:5px">
            Auto Map
        </button>-->
            </div>

            <br />

            <table cellpadding="0" cellspacing="0" class="position-table">
                <thead>
                    <tr>
                        <th style="width: 25%">Job Title</th>
                        <th style="width: 20%">Job Code</th>
                        <th>Position</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="!positionMappingData || !positionTypes">
                        <td colspan="3">
                            <spin-loader [type]="'bounce'"></spin-loader>
                        </td>
                    </tr>
                    <ng-container *ngIf="positionMappingData && positionTypes">
                        <ng-container *ngIf="positionMappingData.length > 0; else noJobFound">
                            <tr *ngFor="let row of positionMappingData">
                                <td>{{ row.jobTitle }}</td>
                                <td>
                                    <input
                                        type="text"
                                        [(ngModel)]="row.jobCode"
                                        (change)="update(row)"
                                        [disabled]="row.staffPositionKey == 0"
                                    />
                                </td>
                                <td>
                                    <select
                                        [(ngModel)]="row.staffPositionKey"
                                        (ngModelChange)="update(row)"
                                    >
                                        <option
                                            *ngFor="let pos of positionTypes"
                                            [value]="pos.staffPositionKey"
                                        >
                                            {{ pos.position }}
                                        </option>
                                    </select>
                                </td>
                            </tr>
                        </ng-container>
                        <ng-template #noJobFound>
                            <tr>
                                <td colspan="3" style="text-align: center; opacity: 0.8">
                                    Job Title Not Found
                                </td>
                            </tr>
                        </ng-template>
                    </ng-container>
                </tbody>
            </table>
        </ng-container>
    </div>
</mat-card>
